import Marquee from "react-fast-marquee";

export function ImageTicker({ images, speed = 40, testId, interactive = false, lightTiles = false }) {
  return (
    <div
      className="bg-[#0A192F] py-8 select-none overflow-hidden"
      data-testid={testId}
      style={{ pointerEvents: interactive ? "auto" : "none", contain: "layout paint style" }}
    >
      <Marquee speed={speed} gradient={false} pauseOnHover={false} pauseOnClick={false} autoFill>
        {images.map((src, i) => (
          <div
            key={i}
            className={`mr-6 h-[230px] flex items-center flex-shrink-0 ${lightTiles ? "bg-[#FAFAF7] px-3 border border-amber-200/30" : ""}`}
            style={{ minWidth: "200px" }}
          >
            <img
              src={src}
              alt=""
              className="h-full w-auto block max-w-none"
              loading="lazy"
              decoding="async"
              draggable={false}
              width={280}
              height={230}
            />
          </div>
        ))}
      </Marquee>
    </div>
  );
}

export function ImageTickerDark({ images, speed = 35, testId, interactive = false }) {
  return (
    <div
      className="py-8 select-none"
      data-testid={testId}
      style={{ pointerEvents: interactive ? "auto" : "none", contain: "layout paint style" }}
    >
      <Marquee speed={speed} gradient={false} pauseOnHover={false} pauseOnClick={false}>
        {images.map((src, i) => (
          <div
            key={i}
            className="mx-4 w-[300px] h-[300px] overflow-hidden border border-amber-300/30 bg-white flex items-center justify-center shadow-[0_8px_30px_rgba(245,158,11,0.08)] flex-shrink-0"
          >
            <img
              src={src}
              alt=""
              className="w-full h-full object-contain"
              loading="lazy"
              decoding="async"
              draggable={false}
              width={300}
              height={300}
            />
          </div>
        ))}
      </Marquee>
    </div>
  );
}

export function TextTicker({ text, testId }) {
  return (
    <div className="bg-[#0A192F] text-white py-3 border-y border-[#172A46] select-none" data-testid={testId}>
      <Marquee speed={60} gradient={false}>
        {Array.from({ length: 12 }).map((_, i) => (
          <span key={i} className="mx-12 rgu-eyebrow text-amber-300">
            {text} <span className="text-slate-500 mx-6">◆</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
